import intl from 'react-intl-universal';
import { CHART_EMPTY_STATE_COLORS, CHART_STYLING } from './chartColors';

export const horizontalBarEmptyState = () => {
  return {
    grid: {
      show: false,
      containLabel: true,
      top: 0,
      bottom: 0,
      right: 0,
      left: 0,
    },
    xAxis: {
      type: 'value',
      show: true,
      axisLine: {
        show: true,
        lineStyle: {
          color: CHART_EMPTY_STATE_COLORS.AXIS_LINE,
          opacity: CHART_EMPTY_STATE_COLORS.AXIS_LINE_OPACITY,
        },
      },
      axisTick: {
        show: true,
        lineStyle: {
          color: CHART_EMPTY_STATE_COLORS.AXIS_LINE,
          opacity: CHART_EMPTY_STATE_COLORS.AXIS_LINE_OPACITY,
        },
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: CHART_EMPTY_STATE_COLORS.AXIS_LINE,
          opacity: CHART_EMPTY_STATE_COLORS.AXIS_LINE_OPACITY,
        },
      },
      axisLabel: {
        show: false,
      },
    },
    yAxis: {
      type: 'category',
      show: true,
      data: [''],
      axisLine: {
        show: true,
        lineStyle: {
          color: CHART_EMPTY_STATE_COLORS.AXIS_LINE,
          opacity: CHART_EMPTY_STATE_COLORS.AXIS_LINE_OPACITY,
        },
      },
      axisTick: {
        show: true,
        lineStyle: {
          color: CHART_EMPTY_STATE_COLORS.AXIS_LINE,
          opacity: CHART_EMPTY_STATE_COLORS.AXIS_LINE_OPACITY,
        },
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: CHART_EMPTY_STATE_COLORS.AXIS_LINE,
          opacity: CHART_EMPTY_STATE_COLORS.AXIS_LINE_OPACITY,
        },
      },
      axisLabel: {
        show: false,
      },
    },
    series: [
      {
        type: 'bar',
        data: [0],
        itemStyle: {
          color: 'transparent',
        },
        label: {
          show: true,
          position: 'right',
          formatter: intl.get('INSIGHT.NO_DATA'),
          fontSize: CHART_STYLING.NO_DATA_FONT_SIZE,
          fontWeight: CHART_STYLING.NO_DATA_FONT_WEIGHT,
          color: CHART_EMPTY_STATE_COLORS.NO_DATA_TEXT,
        },
      },
    ],
    tooltip: {
      show: false,
    },
    legend: {
      show: false,
    },
    textStyle: {
      fontFamily: 'inherit',
    },
  };
};

export const verticalBarEmptyState = () => {
  return {
    grid: {
      show: false,
      containLabel: true,
      top: 0,
      bottom: 8,
      right: 0,
      left: 0,
    },
    xAxis: {
      type: 'category',
      show: true,
      data: [''],
      axisLine: {
        show: true,
        lineStyle: {
          color: CHART_EMPTY_STATE_COLORS.AXIS_LINE,
          opacity: CHART_EMPTY_STATE_COLORS.AXIS_LINE_OPACITY,
        },
      },
      axisTick: {
        show: true,
        lineStyle: {
          color: CHART_EMPTY_STATE_COLORS.AXIS_LINE,
          opacity: CHART_EMPTY_STATE_COLORS.AXIS_LINE_OPACITY,
        },
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: CHART_EMPTY_STATE_COLORS.AXIS_LINE,
          opacity: CHART_EMPTY_STATE_COLORS.AXIS_LINE_OPACITY,
        },
      },
      axisLabel: {
        show: false,
      },
    },
    yAxis: {
      type: 'value',
      show: true,
      axisLine: {
        show: true,
        lineStyle: {
          color: CHART_EMPTY_STATE_COLORS.AXIS_LINE,
          opacity: CHART_EMPTY_STATE_COLORS.AXIS_LINE_OPACITY,
        },
      },
      axisTick: {
        show: true,
        lineStyle: {
          color: CHART_EMPTY_STATE_COLORS.AXIS_LINE,
          opacity: CHART_EMPTY_STATE_COLORS.AXIS_LINE_OPACITY,
        },
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: CHART_EMPTY_STATE_COLORS.AXIS_LINE,
          opacity: CHART_EMPTY_STATE_COLORS.AXIS_LINE_OPACITY,
        },
      },
      axisLabel: {
        show: false,
      },
    },
    series: [
      {
        type: 'bar',
        data: [0],
        itemStyle: {
          color: 'transparent',
        },
        label: {
          show: true,
          position: 'inside',
          formatter: intl.get('INSIGHT.NO_DATA'),
          fontSize: CHART_STYLING.NO_DATA_FONT_SIZE,
          fontWeight: CHART_STYLING.NO_DATA_FONT_WEIGHT,
          color: CHART_EMPTY_STATE_COLORS.NO_DATA_TEXT,
        },
      },
    ],
    tooltip: {
      show: false,
    },
    legend: {
      show: false,
    },
    textStyle: {
      fontFamily: 'inherit',
    },
  };
};

export const horizontalLineEmptyState = () => {
  return {
    grid: {
      show: false,
      containLabel: true,
      top: 0,
      bottom: 0,
      right: 0,
      left: 0,
    },
    xAxis: {
      type: 'category',
      show: true,
      data: [''],
      axisLine: {
        show: true,
        lineStyle: {
          color: CHART_EMPTY_STATE_COLORS.AXIS_LINE,
          opacity: CHART_EMPTY_STATE_COLORS.AXIS_LINE_OPACITY,
        },
      },
      axisTick: {
        show: true,
        lineStyle: {
          color: CHART_EMPTY_STATE_COLORS.AXIS_LINE,
          opacity: CHART_EMPTY_STATE_COLORS.AXIS_LINE_OPACITY,
        },
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: CHART_EMPTY_STATE_COLORS.AXIS_LINE,
          opacity: CHART_EMPTY_STATE_COLORS.AXIS_LINE_OPACITY,
        },
      },
      axisLabel: {
        show: false,
      },
    },
    yAxis: {
      type: 'value',
      show: true,
      axisLine: {
        show: true,
        lineStyle: {
          color: CHART_EMPTY_STATE_COLORS.AXIS_LINE,
          opacity: CHART_EMPTY_STATE_COLORS.AXIS_LINE_OPACITY,
        },
      },
      axisTick: {
        show: true,
        lineStyle: {
          color: CHART_EMPTY_STATE_COLORS.AXIS_LINE,
          opacity: CHART_EMPTY_STATE_COLORS.AXIS_LINE_OPACITY,
        },
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: CHART_EMPTY_STATE_COLORS.AXIS_LINE,
          opacity: CHART_EMPTY_STATE_COLORS.AXIS_LINE_OPACITY,
        },
      },
      axisLabel: {
        show: false,
      },
    },
    series: [
      {
        type: 'line',
        data: [0],
        showSymbol: false,
        lineStyle: {
          opacity: 0,
        },
        itemStyle: {
          opacity: 0,
        },
        label: {
          show: true,
          position: 'inside',
          formatter: intl.get('INSIGHT.NO_DATA'),
          fontSize: CHART_STYLING.NO_DATA_FONT_SIZE,
          fontWeight: CHART_STYLING.NO_DATA_FONT_WEIGHT,
          color: CHART_EMPTY_STATE_COLORS.NO_DATA_TEXT,
        },
      },
    ],
    tooltip: {
      show: false,
    },
    legend: {
      show: false,
    },
    textStyle: {
      fontFamily: 'inherit',
    },
  };
};

export const donutEmptyState = (width: number, height: number) => {
  let diameter = Math.min(width, height);
  let isLandscape = width > height;
  let leftSpace = (width - diameter) / 2;

  return {
    grid: {
      show: false,
      containLabel: true,
      top: 0,
      bottom: 0,
      right: 0,
      left: 0,
    },
    series: [
      {
        type: 'pie',
        radius: isLandscape
          ? [diameter / 4, diameter / 2 - 12]
          : [diameter / 4, diameter / 2 - 24],
        center: isLandscape
          ? [diameter / 2 + leftSpace, '50%']
          : ['50%', height / 2 - 16],
        itemStyle: {
          borderColor: CHART_EMPTY_STATE_COLORS.BORDER_WHITE,
          borderWidth: 1,
        },
        label: {
          show: true,
          position: 'center',
          formatter: intl.get('INSIGHT.NO_DATA'),
          fontSize: CHART_STYLING.NO_DATA_FONT_SIZE,
          fontWeight: CHART_STYLING.NO_DATA_FONT_WEIGHT,
          color: CHART_EMPTY_STATE_COLORS.NO_DATA_TEXT,
        },
        labelLine: {
          show: false,
        },
        data: [
          {
            name: 'No Data',
            value: 1,
            itemStyle: {
              color: 'transparent',
              borderColor: CHART_EMPTY_STATE_COLORS.AXIS_LINE,
              borderWidth: 2,
            },
          },
        ],
      },
    ],
    tooltip: {
      show: false,
    },
    legend: {
      show: false,
    },
    textStyle: {
      fontFamily: 'inherit',
    },
  };
};
